
<div class="customer-widget h-100 transition"  [class.show]="settings.theme.showSideChat"  [class.show-chat-window]="showChatWindow">
    <div style="background-color: #fff !important;border-radius: 10px" >

        <iframe [src]="widgetUrl" id="ucxiframe" frameborder="0" style="width: 100%; min-height: 555px;border: 2px groove #00786a;border-radius: inherit" allow="microphone *; display-capture *; fullscreen *" allowfullscreen></iframe>

    </div>
</div>

